import { createAsyncActionType } from './index';

export const LEARNING_EVENTS_PLANNED_LIST_GET = createAsyncActionType('learningevents', 'LEARNING_EVENTS_PLANNED_LIST_GET');
export const LEARNING_EVENTS_PLANNABLE_LIST_GET = createAsyncActionType('learningevents', 'LEARNING_EVENTS_PLANNABLE_LIST_GET');
